import type { MailboxInfo } from "owa-client-types";
import { getSuffixForLocalStorage } from "owa-feature-flags";
import { getItem, type LocalStorageKeys } from "owa-local-storage";

export const getLocalOverrides = (mailboxInfo: MailboxInfo | undefined): any => {
    const localOverrides = getItem(self, getLocalOverrideStorageKey(mailboxInfo));
    
    if (localOverrides) {
        try {
            return JSON.parse(localOverrides);
        }
        catch {
            return {};
        }
    }
    
    return {};
};

export function getLocalOverrideStorageKey(mailboxInfo: MailboxInfo | undefined): LocalStorageKeys {
    const APPLICATION_SETTING_OVERRIDES_LOCAL_STORAGE_KEY = "applicationSettingOverrides";
    const suffix = getSuffixForLocalStorage(mailboxInfo);
    return `${APPLICATION_SETTING_OVERRIDES_LOCAL_STORAGE_KEY}${suffix}`;
}
